import { Row, Col, Modal, Form, Button, Spinner } from "react-bootstrap"
import { useEffect, useState } from "react";
import { IAppState } from '../../../../../../redux/storeTypes';
import { connect, useDispatch } from "react-redux";
import Table from '../../../../../../components/Table';
import FormHeader from "../../../../../../components/layout/FormHeader";
import { CurrencyFormatter } from "../../../../../../components/Formatters";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { updateOrderDetailsAction, updateShoppingCart } from "../../../../../../redux/actions/orderManagement";
import { sendSuccessToastAction } from "../../../../../../redux/actions/toast";
import { Order } from "../../../../../../models/Order";
import CurrencyInput from '../../../../../../components/currency/CurrencyInput';
import _ from "lodash";

interface ICarbonCountySearchResults {
    webIdLabel: string,
    nameLabel: string,
    addressLabel: string,
    accountIdLabel: string,
    amountDueLabel: string,
    totalAmountDueLabel: string,
    paymentOptionsLabel: string,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    margin: string,
    padding: string,
    headerBackgroundColor: string,
    headerPadding: string,
    itemDetails: any,
    order?: any,
    shoppingCart?: any,
    isFetching: boolean,
    itemSearchDetails?: any
}

export const WEB_ID_LABEL = 'Web ID';
export const NAME_LABEL = 'Name';
export const ADDRESS_LABEL = 'Address';
export const ACCOUNT_ID_LABEL = 'Account ID';
export const AMOUNT_DUE_LABEL = 'Amount Due';
export const TOTAL_AMOUNT_DUE_LABEL = 'Total Amount Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const OVERLAY_TEXT = 'There are no available online payment options on this account at this time.';
export const OVERLAY_BACKGROUND = '#fef1b5';
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

export const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const DateFormatter = (date: any, row: any) => {
    if (date) {
        const dateString = moment(date).format('MM/DD/YYYY');
        return (
            <span>{dateString}</span>
        );
    }
}

const CarbonCountySearchResults = ({ webIdLabel, nameLabel, addressLabel, accountIdLabel, amountDueLabel, totalAmountDueLabel,
    paymentOptionsLabel, itemSearchDetails, overlayText, overlayBackground, overlayTextColor, overlayIconColor,
    margin, padding, headerBackgroundColor, headerPadding, itemDetails, shoppingCart, order, isFetching }: ICarbonCountySearchResults) => {

    if (!webIdLabel) { webIdLabel = WEB_ID_LABEL }
    if (!nameLabel) { nameLabel = NAME_LABEL }
    if (!addressLabel) { addressLabel = ADDRESS_LABEL }
    if (!accountIdLabel) { accountIdLabel = ACCOUNT_ID_LABEL }
    if (!amountDueLabel) { amountDueLabel = AMOUNT_DUE_LABEL }
    if (!totalAmountDueLabel) { totalAmountDueLabel = TOTAL_AMOUNT_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (!overlayText) { overlayText = OVERLAY_TEXT }
    if (!overlayBackground) { overlayBackground = OVERLAY_BACKGROUND }
    if (!overlayTextColor) { overlayTextColor = OVERLAY_TEXT_COLOR }
    if (!overlayIconColor) { overlayIconColor = OVERLAY_ICON_COLOR }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }

    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState<any>({ option: '' });

    const amountFormatter = (cell: any) => {
        return (<span>{formatter.format(cell)}</span>)
    }

    const paymentOptionsFormatter = (cell: any, row: any) => {
        const optionType = row?.metaData?.Amt1 <= 0 && row?.metaData?.Amt2 <= 0 ? '' : row?.metaData?.Amt2 <= 0 ? 'totalDue' : 'due';
        return (
            <span>
                <a
                    onClick={() => { setSelectedRow(row); setCartErrorMessage(''); setSelectedOption({ option: optionType }); setAmount(null); setShowModal(true) }}
                >
                    {paymentOptionsLabel}
                </a>
            </span>
        )
    }

    const initialColumns = [{
        dataField: 'metaData.AccountId',
        text: webIdLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        sort: true,
    }, {
        dataField: 'metaData.Name1',
        text: nameLabel,
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        sort: true,
    }, {
        dataField: 'metaData.Address1',
        text: addressLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
    }, {
        dataField: 'metaData.AccountIdDesc1',
        text: accountIdLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'metaData.Amt2',
        text: amountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        formatter: amountFormatter,
        editable: false,
    }, {
        dataField: 'metaData.Amt1',
        text: totalAmountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: amountFormatter,
    }, {
        dataField: 'metaData.ReferenceNumber',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: paymentOptionsFormatter
    }];

    const [columns, setColumns] = useState<any>(initialColumns);
    const [data, setData] = useState<any>([]);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [amount, setAmount] = useState<any>();
    const [cartErrorMessage, setCartErrorMessage] = useState<string>('');

    const mappingDetails = [
        { heading: webIdLabel, value: selectedRow?.metaData?.AccountId },
        { heading: nameLabel, value: selectedRow?.metaData?.Name1 },
        { heading: addressLabel, value: selectedRow?.metaData?.Address1 },
        { heading: accountIdLabel, value: selectedRow?.metaData?.AccountIdDesc1 },
        { heading: amountDueLabel, value: CurrencyFormatter(selectedRow?.metaData?.Amt2) },
        { heading: totalAmountDueLabel, value: CurrencyFormatter(selectedRow?.metaData?.Amt1) },
    ]

    const handleRadioSelect = (e: any) => {
        setCartErrorMessage('');
        setSelectedOption({ option: e.target.id });
        setAmount(null)
    }

    const partialAmountChange = (value: any) => {
        if (value > selectedRow?.metaData?.Amt1) {
            setCartErrorMessage('Amount cannot be greater than total amount due')
            setAmount(null)
            return
        }
        if (value < 0) {
            setCartErrorMessage('Amount cannot be negative')
            setAmount(null)
            return
        }
        setCartErrorMessage('')
        setAmount(value)
    }

    useEffect(() => {
        if (itemDetails) {
            const filterByKey = itemSearchDetails?.searchBy == 'AccountId';
            const filteredItems = filterByKey ? itemDetails.filter((item: any) => {
                let itemValue = item?.metaData[itemSearchDetails?.searchBy]
                return itemValue === itemSearchDetails?.referenceNumber
            }) : itemDetails;
            setData(filteredItems)
        }
    }, [itemDetails])

    const renderTable = () => {
        if (isFetching) {
            return (<div style={{ textAlign: 'center' }} ><Spinner animation="border" /> </div>);
        }
        else if (data.length === 0) {
            return (<div>Currently there are no records to display. Please do a search to find the record you are looking for.</div>)
        } else {
            return (
                <>
                    <Table
                        keyField="msbId"
                        data={data}
                        remote={false}
                        columns={columns}
                        sizePerPage={5}
                    />
                </>);
        }
    };

    const inCart = shoppingCart?.some((cart: any) => cart?.id === selectedRow?.metaData?.ReferenceNumber);
    const handleSubmit = (e: any) => {
        e.preventDefault();
        const shoppingCartObject = [
            {
                webId: selectedRow?.metaData?.AccountId,
                name: selectedRow?.metaData?.Name1,
                address: selectedRow?.metaData?.Address1,
                accountId: selectedRow?.metaData?.AccountIdDesc1,
                amountDue: selectedRow?.metaData?.Amt2,
                totalAmountDue: selectedRow?.metaData?.Amt1,
                id: selectedRow?.metaData?.ReferenceNumber,
                paymentAmount: selectedOption?.option === 'partial' ? _.toNumber(amount) : selectedOption?.option === 'due' ? Number(selectedRow?.metaData?.Amt2) : Number(selectedRow?.metaData?.Amt1),
            }];
        const OrderLinesObject = [
            {
                itemReferenceNumber: selectedRow?.metaData?.ReferenceNumber,
                quantity: 1,
                unitPrice: selectedOption?.option === 'partial' ? _.toNumber(amount) : selectedOption?.option === 'due' ? Number(selectedRow?.metaData?.Amt2) : Number(selectedRow?.metaData?.Amt1),
                itemMetadata: {
                    uiReferenceId: selectedRow?.metaData?.ReferenceNumber,
                    itemMsbid: selectedRow?.msbId,
                    accountId: selectedRow?.metaData?.AccountId,
                    amt1Desc: selectedRow?.metaData?.Amt1Desc,
                    amt2Desc: selectedRow?.metaData?.Amt2Desc,
                    partnerId: selectedRow?.metaData?.PartnerId,
                    amt2: Number(selectedRow?.metaData?.Amt2),
                    amt1: Number(selectedRow?.metaData?.Amt1),
                    email: selectedRow?.metaData?.['E-Mail'],
                    prodId: selectedRow?.metaData?.ProdId
                },
                itemName: selectedRow?.metaData?.AccountId,
            }];
        if (order) {
            const updatedOrderLines = order?.orderLines.filter((orderLine: any) => !OrderLinesObject.some((selected: any) => orderLine?.itemMetadata?.uiReferenceId === selected?.itemMetadata?.uiReferenceId)).concat(OrderLinesObject);
            const updatedShoppingCart = shoppingCart.filter((cart: any) => !shoppingCartObject.some((selected: any) => cart?.id === selected?.id)).concat(shoppingCartObject);
            order.methodName = "Sale";
            order.orderLines = updatedOrderLines;
            dispatch(updateShoppingCart(updatedShoppingCart, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(order, 'actionToken'));
        }
        else {
            let _order = new Order();
            _order.methodName = "Sale";
            _order.orderLines = OrderLinesObject;
            dispatch(updateShoppingCart(shoppingCartObject, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(_order, 'actionToken'));
        }
        dispatch(sendSuccessToastAction('Added to cart'))
        setShowModal(false);
    }

    return (

        <div style={{ margin: margin, padding: padding }}>
            <Row><Col>{renderTable()}</Col></Row>
            <Modal show={showModal} size={'lg'} backdrop="static" onHide={() => setShowModal(false)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <FormHeader title="Item Details" description={"Below are the selected item details"} />
                    <Form.Group controlId="printTerminal" >
                        <>
                            {Object.entries(mappingDetails).map(
                                ([index, selectedArray]: any) => {
                                    return (
                                        <div key={index} className="neric_details_row">
                                            <h3>{selectedArray.heading}</h3>
                                            <span>{selectedArray.value}</span>
                                        </div>
                                    )
                                }
                            )}
                        </>
                    </Form.Group>
                    <hr />
                    {!inCart ?
                        <>
                            <FormHeader title="Payment Options" description={"Please select one of the following payment options"} />
                            <Form.Group controlId="paymentOptions">
                                <div className='stCharles_cart'>
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='due'
                                                onChange={handleRadioSelect}
                                                disabled={Number(selectedRow?.metaData?.Amt2) <= 0}
                                                checked={selectedOption?.option === 'due'}
                                            />
                                            Amount Due :
                                        </label>
                                        <span className='box_span'>{formatter.format(Number(selectedRow?.metaData?.Amt2))}</span>
                                    </div>
                                    <br />
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='totalDue'
                                                onChange={(e) => setSelectedOption({ option: `${e.target.id}` })}
                                                checked={selectedOption?.option === 'totalDue'}
                                            />Total Amount Due :
                                        </label>
                                        <span className='box_span'>{formatter.format(Number(selectedRow?.metaData?.Amt1))}</span>
                                    </div>
                                    <br />
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='partial'
                                                onChange={(e) => setSelectedOption({ option: `${e.target.id}` })}
                                                checked={selectedOption?.option === 'partial'}
                                            />Other Amount :
                                        </label>
                                        <Form.Group controlId="amount" className='box_span'>
                                            <CurrencyInput
                                                required
                                                className="form-control"
                                                id="summaryAmount"
                                                name="summaryAmount"
                                                placeholder="$ 0.00"
                                                maxLength={10}
                                                decimalsLimit={2}
                                                prefix="$ "
                                                disabled={selectedOption?.option != 'partial'}
                                                value={amount}
                                                onValueChange={(value: any) => partialAmountChange(value)}
                                            />
                                        </Form.Group>
                                        {cartErrorMessage && selectedOption?.option === 'partial' &&
                                            <div role="alert" id="paymentErrorBox" style={{ color: 'red' }}>
                                                <FontAwesomeIcon icon={faTimesCircle} color='red' /> {cartErrorMessage}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form.Group>
                        </>
                        :
                        <div className="stCharles-accordion accordion">
                            <div className='card'>
                                <div className='agreement_toggle_header card-header' style={{ justifyContent: 'center' }}>
                                    <FontAwesomeIcon color='green' icon={faCartPlus} />Added to cart
                                </div>
                            </div>
                        </div>
                    }
                    <Form.Group className="form-footer">
                        <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button type="submit"
                            disabled={inCart || (selectedRow?.metaData?.Amt2 <= 0 && selectedRow?.metaData?.Amt1 <= 0) || (selectedOption?.option === 'partial' && !amount)} onClick={(e) => handleSubmit(e)}
                        >
                            {`Add to cart`}
                        </Button>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state: IAppState) => {
    return {
        isFetching: state.account.isFetching,
        itemDetails: state.account.itemDetails,
        shoppingCart: state.orderManagement.shoppingCart,
        order: state.orderManagement.order,
        itemSearchDetails: state.orderManagement.itemSearchDetails
    };
};

export default connect(mapStateToProps)(CarbonCountySearchResults);